import React from "react";
import Header from "../directives/header";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Tab,
  Nav,
  InputGroup,
  Form,
} from "react-bootstrap";
import "../css/home2.css";
import Footer from "../directives/footer";

const Home2 = () => {
  return (
    <>
      <div className="home2">
        <Header />
        <section className="herobanner position-relative">
          <div className="bgleft position-absolute top-0 bottom-0 start-0">
            <img src="assets/images/shape/bgleftshadow.svg" />
          </div>
          <div className="bgright position-absolute top-0 bottom-0 end-0">
            <img src="assets/images/shape/blueshadow.svg" />
          </div>
          <Container className="position-relative">
            <Row className="align-items-center">
              <Col lg={7} className="pt-5 mb-4">
           
                <div className="bannerContent">
                  <h1 className="text-uppercase fw-bold text-white">
                    Crypto World{" "}
                    <div className="text-primary your_reach">at Your Reach.</div>
                  </h1>

                  <div className="mt-4">
                    <img src="assets/images/logo/utxName.svg" />
                  </div>
                  <p className="my-4">
                    UNITRONIX believe all project stakeholders are as important
                    as each other. Investment funds and communities should work
                    side by side on projects, on the same terms, towards the
                    same goals.
                  </p>
                </div>
                <div>
                  <Button
                    variant="primary-gradient"
                    className="border-0 text-capitalize fw-normal me-1"
                  >
                    Learn More about our Strategy
                  </Button>

                  <Button
                    variant="default"
                    className="border-0 fw-semibold me-1 text-white"
                  >
                    What is UTX?{" "}
                    <span className="ms-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          d="M4 12.4789H20M20 12.4789L14 18.4789M20 12.4789L14 6.47894"
                          stroke="#61C19B"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </Button>
                  <Button
                    variant="default"
                    className="border-0 fw-semibold text-white"
                  >
                    Read about the UTX Deck
                    <span className="ms-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          d="M6 18.4789L18 6.47894M18 6.47894H10M18 6.47894V14.4789"
                          stroke="#61C19B"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </Button>
                </div>
           
              </Col>
              <Col lg={5} className="pt-5 mb-4 text-center">
           
                <div className="bannerImage">
                    <img src="assets/images/utx.gif"  className="w-100"/>
                </div>
           
           
              </Col>
            </Row>
          </Container>
        </section>
        <section className=" py-0 position-relative">
          <div className="bgleft position-absolute top-0 bottom-0 start-0">
            <img src="assets/images/shape/bgleftline2.svg" />
          </div>
          <Container>
            <Row>
              <Col xl={6} className="mb-4">
             
                <div className="investment">
                  <Card className="mh-100 greenCard">
                    <Card.Body className="">
                      <div>
                        <Row className="align-items-center">
                          <Col lg={6} className="">
                            <div>
                              <img
                                src="assets/images/investment2.svg"
                                className="w-100"
                              />
                            </div>
                          </Col>
                          <Col lg={6} className="">
                            <div className="">
                              <h3
                                className="fw-semibold text-white"
                                style={{ lineHeight: "47.6px" }}
                              >
                                Make Crypto Investment Safer Again
                              </h3>
                              <p className="mt-2 mb-3 small">
                                Experience full stack decentralization: from
                                DAOs and crypto cloud services to games, NFTs,
                                and social media,
                              </p>
                              <Button
                                variant="outline-white"
                                className="border"
                              >
                                Find Out More
                              </Button>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
          
              </Col>
              <Col xl={6} className="mb-4">

                <Card className="mh-100">
                  <Card.Body className="p-0">
                    <div className="matrixBox position-relative overflow-hidden mb-4 sameHeight">
                      <div className="bgImg position-absolute start-0 end-0 top-0 bottom-0">
                        <img
                          src="assets/images/utxvideo.gif"
                          width={`100%`}
                          height={`100%`}
                          style={{ opacity: "0.5" }}
                        />
                      </div>
                      <Row className="sameHeight align-items-center">
                        <Col lg={12} className="">
                          <Card className="bg-transparent">
                            <Card.Body className=" ">
                              <div className="text-center  px-3">
                                <div className="">
                                  <img src="assets/images/logo/utxName.svg" />
                                </div>
                                <h1 className="mb-0 text-white fw-bold">
                                  MATRIX
                                </h1>
                                <p className="fw-light small">
                                  Create smart contracts that can trustlessly
                                  interact with, and coordinate, multiple
                                  blockchains. Process any token. Interact with
                                  any smart contract.
                                </p>
                                <Button
                                  variant="primary"
                                  className="text-black"
                                >
                                  Find Out More
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
             
              </Col>
            </Row>
          </Container>
        </section>
        <section className="howitwork py-0">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8} className="mb-4 text-center">
                <div className="heading my-4 ">
                  <h1 className="text-white fw-normal">How it Works.</h1>
                </div>
                <p className="fs-5">
                  Most notably project tokens can be obtained at the same price
                  large crypto investment funds get them, promoting equality
                  among stakeholders.
                </p>
              </Col>
            </Row>
            <Row>
              <Col lg={12} className="mb-5">
                <Card>
                  <Card.Body className="pb-0 ">
                    <div>
                      <Row className="align-items-center">
                        <Col lg={12} className="">
                          <div className="tabStyle">
                            <Tab.Container
                              id="left-tabs-example"
                              defaultActiveKey="holders"
                            >
                              <Row>
                                <Col xl={3} lg={4} md={5}>
                                  <Nav variant="pills" className="flex-column">
                                    <Nav.Item className="mb-4">
                                      <Nav.Link eventKey="holders">
                                        <div className="d-flex align-items-center position-relative">
                                          <div>
                                            <i className="me-3">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="35"
                                                height="35"
                                                viewBox="0 0 40 41"
                                                fill="none"
                                              >
                                                <path
                                                  d="M16.7333 35.4846C18.3587 35.5289 19.9338 34.9183 21.1046 33.79C23.8339 31.06 23.1999 25.9853 19.6906 22.476C16.1813 18.9666 11.1053 18.3326 8.37661 21.062C5.64794 23.7913 6.28194 28.866 9.79128 32.3753C11.6102 34.2789 14.1019 35.395 16.7333 35.4846ZM9.31928 22.0046C10.2413 21.1215 11.4798 20.6465 12.7559 20.6866C15.0325 20.7849 17.1814 21.7652 18.7479 23.42C21.7366 26.4093 22.3719 30.6386 20.1619 32.8486C17.9519 35.0586 13.7233 34.422 10.7333 31.4333C7.74328 28.4446 7.11061 24.214 9.31928 22.0046Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M5.54872 36.618C7.86999 39.0202 11.0439 40.4117 14.3834 40.4913C16.7119 40.5425 18.9635 39.6569 20.6334 38.0333L22.9901 35.6767C24.8675 33.7332 25.7562 31.0398 25.4041 28.3607C25.0592 25.408 23.7073 22.6644 21.5761 20.592C19.5036 18.4609 16.76 17.109 13.8074 16.764C11.1284 16.4117 8.43494 17.3002 6.49139 19.1773L4.13339 21.5333C0.365391 25.3 1.00006 32.0693 5.54872 36.618ZM12.7334 18.042C13.0471 18.0421 13.3606 18.0579 13.6727 18.0893C16.3199 18.4031 18.778 19.6193 20.6334 21.5333C22.5466 23.3884 23.7628 25.8457 24.0774 28.492C24.3864 30.7728 23.6391 33.0701 22.0474 34.7327C20.3851 36.3244 18.088 37.0717 15.8074 36.7627C13.161 36.4476 10.7037 35.2316 8.84806 33.3187C6.93517 31.4631 5.71908 29.0057 5.40406 26.3593C5.095 24.0785 5.84229 21.7812 7.43406 20.1187C8.84983 18.7427 10.7597 17.9943 12.7334 18.042ZM4.20006 23.572C4.01762 24.5342 3.97563 25.5178 4.07539 26.492C4.42091 29.4447 5.77269 32.1883 7.90339 34.2613C9.97647 36.392 12.7201 37.7438 15.6727 38.0893C16.0367 38.1253 16.3958 38.1433 16.7501 38.1433C17.3643 38.1437 17.9772 38.0863 18.5807 37.972C15.2154 40.158 10.0974 39.2827 6.48939 35.6753C2.88139 32.068 2.00606 26.9367 4.20006 23.572Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M7.65801 3.34334C5.96534 2.93401 4.50868 3.23334 3.55601 4.18667C2.60334 5.14001 2.30401 6.596 2.71268 8.28867C3.18765 10.0254 4.12332 11.6015 5.42068 12.85C7.29734 14.7273 9.51934 15.742 11.3793 15.7413C12.3827 15.7782 13.3584 15.4079 14.0847 14.7147C15.99 12.808 15.1713 9.00267 12.218 6.05134C10.9702 4.75369 9.39454 3.81794 7.65801 3.34334ZM13.142 13.772C11.8087 15.102 8.70668 14.25 6.36334 11.9053C5.23892 10.83 4.42564 9.47111 4.00934 7.97201C3.71268 6.74801 3.88734 5.73734 4.49868 5.12601C4.97393 4.69111 5.60406 4.46553 6.24734 4.50001C6.61761 4.50348 6.98616 4.5507 7.34534 4.64067C8.84453 5.05713 10.2035 5.87065 11.2787 6.99534C13.6193 9.33601 14.4733 12.4407 13.142 13.772Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M37.0773 6.42536L35.0773 4.42536C32.698 2.04403 27.9173 3.10003 24.194 6.82403C22.5482 8.40628 21.361 10.4041 20.758 12.606C20.248 14.718 20.6153 16.5287 21.7926 17.7067H21.796L23.796 19.7067C24.6962 20.5641 25.905 21.0209 27.1473 20.9734C29.4873 20.9734 32.2986 19.684 34.6806 17.3067C38.4 13.5834 39.456 8.80336 37.0773 6.42536ZM22.054 12.9187C22.5997 10.9555 23.6646 9.17568 25.1366 7.76669C27.218 5.68536 29.7673 4.50736 31.7566 4.50736C32.6321 4.46334 33.4885 4.77299 34.1333 5.36669C34.968 6.20336 35.21 7.56669 34.8133 9.20936C34.2688 11.1729 33.2048 12.9532 31.7333 14.3627C28.6433 17.452 24.524 18.5507 22.7333 16.7627C21.8993 15.9274 21.6566 14.562 22.054 12.9187ZM24.9826 18.9667C25.036 18.9667 25.0886 18.9727 25.1433 18.9727C27.484 18.9727 30.2953 17.6834 32.6766 15.3027C34.3217 13.7203 35.5087 11.7228 36.112 9.52136C36.2671 8.89012 36.3383 8.24121 36.324 7.59136C37.8266 9.47936 36.7033 13.3914 33.736 16.3627C30.7773 19.3227 26.8793 20.45 24.9826 18.9667Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M17.87 0.5C17.5018 0.5 17.2034 0.798477 17.2034 1.16667V3.16667C17.2034 3.53486 17.5018 3.83333 17.87 3.83333C18.2382 3.83333 18.5367 3.53486 18.5367 3.16667V1.16667C18.5367 0.798477 18.2382 0.5 17.87 0.5Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M17.2034 7.83329C17.2034 8.20148 17.5018 8.49996 17.87 8.49996C18.2382 8.49996 18.5367 8.20148 18.5367 7.83329V5.83329C18.5367 5.4651 18.2382 5.16663 17.87 5.16663C17.5018 5.16663 17.2034 5.4651 17.2034 5.83329V7.83329Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M19.2033 5.16671H21.2033C21.5715 5.16671 21.87 4.86823 21.87 4.50004C21.87 4.13185 21.5715 3.83337 21.2033 3.83337H19.2033C18.8351 3.83337 18.5366 4.13185 18.5366 4.50004C18.5366 4.86823 18.8351 5.16671 19.2033 5.16671Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M16.5368 3.83337H14.5368C14.1686 3.83337 13.8701 4.13185 13.8701 4.50004C13.8701 4.86823 14.1686 5.16671 14.5368 5.16671H16.5368C16.905 5.16671 17.2035 4.86823 17.2035 4.50004C17.2035 4.13185 16.905 3.83337 16.5368 3.83337Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M33.4715 24.6953C33.2112 24.4351 32.7892 24.4351 32.5288 24.6953L31.1955 26.0286C31.0222 26.196 30.9527 26.4439 31.0137 26.677C31.0747 26.9101 31.2567 27.0921 31.4898 27.1531C31.7229 27.2141 31.9708 27.1446 32.1382 26.9713L33.4715 25.638C33.7317 25.3776 33.7317 24.9556 33.4715 24.6953Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M29.1953 28.0287L27.862 29.362C27.6887 29.5294 27.6192 29.7773 27.6802 30.0104C27.7412 30.2435 27.9232 30.4255 28.1563 30.4865C28.3894 30.5475 28.6373 30.478 28.8047 30.3047L30.138 28.9714C30.3906 28.7098 30.387 28.294 30.1299 28.0368C29.8727 27.7797 29.4569 27.776 29.1953 28.0287Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M32.1381 28.0287C31.8765 27.776 31.4607 27.7797 31.2036 28.0368C30.9464 28.294 30.9428 28.7098 31.1954 28.9714L32.5288 30.3047C32.7904 30.5573 33.2062 30.5537 33.4633 30.2966C33.7205 30.0394 33.7241 29.6236 33.4714 29.362L32.1381 28.0287Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M30.1379 26.0287L28.8046 24.6953C28.543 24.4427 28.1272 24.4463 27.8701 24.7034C27.6129 24.9606 27.6093 25.3764 27.8619 25.638L29.1953 26.9713C29.4569 27.224 29.8727 27.2204 30.1298 26.9632C30.387 26.706 30.3906 26.2902 30.1379 26.0287Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M12.0353 29.1C12.1935 29.1791 12.3767 29.1921 12.5445 29.1361C12.7123 29.0801 12.851 28.9597 12.93 28.8014L15.5966 23.468C15.7612 23.1385 15.6275 22.7379 15.298 22.5734C14.9684 22.4088 14.5679 22.5425 14.4033 22.872L11.7366 28.2054C11.6575 28.3636 11.6445 28.5468 11.7006 28.7146C11.7566 28.8824 11.877 29.021 12.0353 29.1Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M14.702 31.1C14.8603 31.1791 15.0435 31.1921 15.2113 31.136C15.3791 31.08 15.5177 30.9596 15.5967 30.8013L16.93 28.1346C17.0946 27.8051 16.9609 27.4046 16.6314 27.24C16.3019 27.0754 15.9013 27.2091 15.7367 27.5386L14.4034 30.2053C14.3243 30.3635 14.3113 30.5467 14.3673 30.7145C14.4233 30.8823 14.5437 31.021 14.702 31.1Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M25.74 11.0526C25.8118 11.0528 25.8832 11.0411 25.9513 11.0179L31.608 9.13261C31.9577 9.01608 32.1468 8.63806 32.0303 8.28828C31.9138 7.9385 31.5357 7.74942 31.186 7.86595L25.5293 9.75328C25.2188 9.85644 25.029 10.1697 25.0814 10.4926C25.1338 10.8156 25.4128 11.0529 25.74 11.0526Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M28.8287 12.11L26 13.0534C25.7738 13.1287 25.6049 13.3191 25.557 13.5528C25.5092 13.7864 25.5896 14.0278 25.768 14.1861C25.9465 14.3444 26.1958 14.3954 26.422 14.32L29.25 13.3774C29.5998 13.2608 29.7889 12.8828 29.6724 12.533C29.5558 12.1833 29.1778 11.9942 28.828 12.1107L28.8287 12.11Z"
                                                  fill="#61C19B"
                                                />
                                              </svg>
                                            </i>
                                          </div>
                                          <div>UNITRONIX Holders</div>
                                        </div>
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item className="mb-4">
                                      <Nav.Link eventKey="point2">
                                        <div className="d-flex align-items-center position-relative">
                                          <div>
                                            <i className="me-3">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="35"
                                                height="35"
                                                viewBox="0 0 40 41"
                                                fill="none"
                                              >
                                                <path
                                                  d="M16.7333 35.4846C18.3587 35.5289 19.9338 34.9183 21.1046 33.79C23.8339 31.06 23.1999 25.9853 19.6906 22.476C16.1813 18.9666 11.1053 18.3326 8.37661 21.062C5.64794 23.7913 6.28194 28.866 9.79128 32.3753C11.6102 34.2789 14.1019 35.395 16.7333 35.4846ZM9.31928 22.0046C10.2413 21.1215 11.4798 20.6465 12.7559 20.6866C15.0325 20.7849 17.1814 21.7652 18.7479 23.42C21.7366 26.4093 22.3719 30.6386 20.1619 32.8486C17.9519 35.0586 13.7233 34.422 10.7333 31.4333C7.74328 28.4446 7.11061 24.214 9.31928 22.0046Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M5.54872 36.618C7.86999 39.0202 11.0439 40.4117 14.3834 40.4913C16.7119 40.5425 18.9635 39.6569 20.6334 38.0333L22.9901 35.6767C24.8675 33.7332 25.7562 31.0398 25.4041 28.3607C25.0592 25.408 23.7073 22.6644 21.5761 20.592C19.5036 18.4609 16.76 17.109 13.8074 16.764C11.1284 16.4117 8.43494 17.3002 6.49139 19.1773L4.13339 21.5333C0.365391 25.3 1.00006 32.0693 5.54872 36.618ZM12.7334 18.042C13.0471 18.0421 13.3606 18.0579 13.6727 18.0893C16.3199 18.4031 18.778 19.6193 20.6334 21.5333C22.5466 23.3884 23.7628 25.8457 24.0774 28.492C24.3864 30.7728 23.6391 33.0701 22.0474 34.7327C20.3851 36.3244 18.088 37.0717 15.8074 36.7627C13.161 36.4476 10.7037 35.2316 8.84806 33.3187C6.93517 31.4631 5.71908 29.0057 5.40406 26.3593C5.095 24.0785 5.84229 21.7812 7.43406 20.1187C8.84983 18.7427 10.7597 17.9943 12.7334 18.042ZM4.20006 23.572C4.01762 24.5342 3.97563 25.5178 4.07539 26.492C4.42091 29.4447 5.77269 32.1883 7.90339 34.2613C9.97647 36.392 12.7201 37.7438 15.6727 38.0893C16.0367 38.1253 16.3958 38.1433 16.7501 38.1433C17.3643 38.1437 17.9772 38.0863 18.5807 37.972C15.2154 40.158 10.0974 39.2827 6.48939 35.6753C2.88139 32.068 2.00606 26.9367 4.20006 23.572Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M7.65801 3.34334C5.96534 2.93401 4.50868 3.23334 3.55601 4.18667C2.60334 5.14001 2.30401 6.596 2.71268 8.28867C3.18765 10.0254 4.12332 11.6015 5.42068 12.85C7.29734 14.7273 9.51934 15.742 11.3793 15.7413C12.3827 15.7782 13.3584 15.4079 14.0847 14.7147C15.99 12.808 15.1713 9.00267 12.218 6.05134C10.9702 4.75369 9.39454 3.81794 7.65801 3.34334ZM13.142 13.772C11.8087 15.102 8.70668 14.25 6.36334 11.9053C5.23892 10.83 4.42564 9.47111 4.00934 7.97201C3.71268 6.74801 3.88734 5.73734 4.49868 5.12601C4.97393 4.69111 5.60406 4.46553 6.24734 4.50001C6.61761 4.50348 6.98616 4.5507 7.34534 4.64067C8.84453 5.05713 10.2035 5.87065 11.2787 6.99534C13.6193 9.33601 14.4733 12.4407 13.142 13.772Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M37.0773 6.42536L35.0773 4.42536C32.698 2.04403 27.9173 3.10003 24.194 6.82403C22.5482 8.40628 21.361 10.4041 20.758 12.606C20.248 14.718 20.6153 16.5287 21.7926 17.7067H21.796L23.796 19.7067C24.6962 20.5641 25.905 21.0209 27.1473 20.9734C29.4873 20.9734 32.2986 19.684 34.6806 17.3067C38.4 13.5834 39.456 8.80336 37.0773 6.42536ZM22.054 12.9187C22.5997 10.9555 23.6646 9.17568 25.1366 7.76669C27.218 5.68536 29.7673 4.50736 31.7566 4.50736C32.6321 4.46334 33.4885 4.77299 34.1333 5.36669C34.968 6.20336 35.21 7.56669 34.8133 9.20936C34.2688 11.1729 33.2048 12.9532 31.7333 14.3627C28.6433 17.452 24.524 18.5507 22.7333 16.7627C21.8993 15.9274 21.6566 14.562 22.054 12.9187ZM24.9826 18.9667C25.036 18.9667 25.0886 18.9727 25.1433 18.9727C27.484 18.9727 30.2953 17.6834 32.6766 15.3027C34.3217 13.7203 35.5087 11.7228 36.112 9.52136C36.2671 8.89012 36.3383 8.24121 36.324 7.59136C37.8266 9.47936 36.7033 13.3914 33.736 16.3627C30.7773 19.3227 26.8793 20.45 24.9826 18.9667Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M17.87 0.5C17.5018 0.5 17.2034 0.798477 17.2034 1.16667V3.16667C17.2034 3.53486 17.5018 3.83333 17.87 3.83333C18.2382 3.83333 18.5367 3.53486 18.5367 3.16667V1.16667C18.5367 0.798477 18.2382 0.5 17.87 0.5Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M17.2034 7.83329C17.2034 8.20148 17.5018 8.49996 17.87 8.49996C18.2382 8.49996 18.5367 8.20148 18.5367 7.83329V5.83329C18.5367 5.4651 18.2382 5.16663 17.87 5.16663C17.5018 5.16663 17.2034 5.4651 17.2034 5.83329V7.83329Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M19.2033 5.16671H21.2033C21.5715 5.16671 21.87 4.86823 21.87 4.50004C21.87 4.13185 21.5715 3.83337 21.2033 3.83337H19.2033C18.8351 3.83337 18.5366 4.13185 18.5366 4.50004C18.5366 4.86823 18.8351 5.16671 19.2033 5.16671Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M16.5368 3.83337H14.5368C14.1686 3.83337 13.8701 4.13185 13.8701 4.50004C13.8701 4.86823 14.1686 5.16671 14.5368 5.16671H16.5368C16.905 5.16671 17.2035 4.86823 17.2035 4.50004C17.2035 4.13185 16.905 3.83337 16.5368 3.83337Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M33.4715 24.6953C33.2112 24.4351 32.7892 24.4351 32.5288 24.6953L31.1955 26.0286C31.0222 26.196 30.9527 26.4439 31.0137 26.677C31.0747 26.9101 31.2567 27.0921 31.4898 27.1531C31.7229 27.2141 31.9708 27.1446 32.1382 26.9713L33.4715 25.638C33.7317 25.3776 33.7317 24.9556 33.4715 24.6953Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M29.1953 28.0287L27.862 29.362C27.6887 29.5294 27.6192 29.7773 27.6802 30.0104C27.7412 30.2435 27.9232 30.4255 28.1563 30.4865C28.3894 30.5475 28.6373 30.478 28.8047 30.3047L30.138 28.9714C30.3906 28.7098 30.387 28.294 30.1299 28.0368C29.8727 27.7797 29.4569 27.776 29.1953 28.0287Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M32.1381 28.0287C31.8765 27.776 31.4607 27.7797 31.2036 28.0368C30.9464 28.294 30.9428 28.7098 31.1954 28.9714L32.5288 30.3047C32.7904 30.5573 33.2062 30.5537 33.4633 30.2966C33.7205 30.0394 33.7241 29.6236 33.4714 29.362L32.1381 28.0287Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M30.1379 26.0287L28.8046 24.6953C28.543 24.4427 28.1272 24.4463 27.8701 24.7034C27.6129 24.9606 27.6093 25.3764 27.8619 25.638L29.1953 26.9713C29.4569 27.224 29.8727 27.2204 30.1298 26.9632C30.387 26.706 30.3906 26.2902 30.1379 26.0287Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M12.0353 29.1C12.1935 29.1791 12.3767 29.1921 12.5445 29.1361C12.7123 29.0801 12.851 28.9597 12.93 28.8014L15.5966 23.468C15.7612 23.1385 15.6275 22.7379 15.298 22.5734C14.9684 22.4088 14.5679 22.5425 14.4033 22.872L11.7366 28.2054C11.6575 28.3636 11.6445 28.5468 11.7006 28.7146C11.7566 28.8824 11.877 29.021 12.0353 29.1Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M14.702 31.1C14.8603 31.1791 15.0435 31.1921 15.2113 31.136C15.3791 31.08 15.5177 30.9596 15.5967 30.8013L16.93 28.1346C17.0946 27.8051 16.9609 27.4046 16.6314 27.24C16.3019 27.0754 15.9013 27.2091 15.7367 27.5386L14.4034 30.2053C14.3243 30.3635 14.3113 30.5467 14.3673 30.7145C14.4233 30.8823 14.5437 31.021 14.702 31.1Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M25.74 11.0526C25.8118 11.0528 25.8832 11.0411 25.9513 11.0179L31.608 9.13261C31.9577 9.01608 32.1468 8.63806 32.0303 8.28828C31.9138 7.9385 31.5357 7.74942 31.186 7.86595L25.5293 9.75328C25.2188 9.85644 25.029 10.1697 25.0814 10.4926C25.1338 10.8156 25.4128 11.0529 25.74 11.0526Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M28.8287 12.11L26 13.0534C25.7738 13.1287 25.6049 13.3191 25.557 13.5528C25.5092 13.7864 25.5896 14.0278 25.768 14.1861C25.9465 14.3444 26.1958 14.3954 26.422 14.32L29.25 13.3774C29.5998 13.2608 29.7889 12.8828 29.6724 12.533C29.5558 12.1833 29.1778 11.9942 28.828 12.1107L28.8287 12.11Z"
                                                  fill="#61C19B"
                                                />
                                              </svg>
                                            </i>
                                          </div>
                                          <div>Point2</div>
                                        </div>
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                      <Nav.Link eventKey="point3">
                                        <div className="d-flex align-items-center position-relative">
                                          <div>
                                            <i className="me-3">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="35"
                                                height="35"
                                                viewBox="0 0 40 41"
                                                fill="none"
                                              >
                                                <path
                                                  d="M16.7333 35.4846C18.3587 35.5289 19.9338 34.9183 21.1046 33.79C23.8339 31.06 23.1999 25.9853 19.6906 22.476C16.1813 18.9666 11.1053 18.3326 8.37661 21.062C5.64794 23.7913 6.28194 28.866 9.79128 32.3753C11.6102 34.2789 14.1019 35.395 16.7333 35.4846ZM9.31928 22.0046C10.2413 21.1215 11.4798 20.6465 12.7559 20.6866C15.0325 20.7849 17.1814 21.7652 18.7479 23.42C21.7366 26.4093 22.3719 30.6386 20.1619 32.8486C17.9519 35.0586 13.7233 34.422 10.7333 31.4333C7.74328 28.4446 7.11061 24.214 9.31928 22.0046Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M5.54872 36.618C7.86999 39.0202 11.0439 40.4117 14.3834 40.4913C16.7119 40.5425 18.9635 39.6569 20.6334 38.0333L22.9901 35.6767C24.8675 33.7332 25.7562 31.0398 25.4041 28.3607C25.0592 25.408 23.7073 22.6644 21.5761 20.592C19.5036 18.4609 16.76 17.109 13.8074 16.764C11.1284 16.4117 8.43494 17.3002 6.49139 19.1773L4.13339 21.5333C0.365391 25.3 1.00006 32.0693 5.54872 36.618ZM12.7334 18.042C13.0471 18.0421 13.3606 18.0579 13.6727 18.0893C16.3199 18.4031 18.778 19.6193 20.6334 21.5333C22.5466 23.3884 23.7628 25.8457 24.0774 28.492C24.3864 30.7728 23.6391 33.0701 22.0474 34.7327C20.3851 36.3244 18.088 37.0717 15.8074 36.7627C13.161 36.4476 10.7037 35.2316 8.84806 33.3187C6.93517 31.4631 5.71908 29.0057 5.40406 26.3593C5.095 24.0785 5.84229 21.7812 7.43406 20.1187C8.84983 18.7427 10.7597 17.9943 12.7334 18.042ZM4.20006 23.572C4.01762 24.5342 3.97563 25.5178 4.07539 26.492C4.42091 29.4447 5.77269 32.1883 7.90339 34.2613C9.97647 36.392 12.7201 37.7438 15.6727 38.0893C16.0367 38.1253 16.3958 38.1433 16.7501 38.1433C17.3643 38.1437 17.9772 38.0863 18.5807 37.972C15.2154 40.158 10.0974 39.2827 6.48939 35.6753C2.88139 32.068 2.00606 26.9367 4.20006 23.572Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M7.65801 3.34334C5.96534 2.93401 4.50868 3.23334 3.55601 4.18667C2.60334 5.14001 2.30401 6.596 2.71268 8.28867C3.18765 10.0254 4.12332 11.6015 5.42068 12.85C7.29734 14.7273 9.51934 15.742 11.3793 15.7413C12.3827 15.7782 13.3584 15.4079 14.0847 14.7147C15.99 12.808 15.1713 9.00267 12.218 6.05134C10.9702 4.75369 9.39454 3.81794 7.65801 3.34334ZM13.142 13.772C11.8087 15.102 8.70668 14.25 6.36334 11.9053C5.23892 10.83 4.42564 9.47111 4.00934 7.97201C3.71268 6.74801 3.88734 5.73734 4.49868 5.12601C4.97393 4.69111 5.60406 4.46553 6.24734 4.50001C6.61761 4.50348 6.98616 4.5507 7.34534 4.64067C8.84453 5.05713 10.2035 5.87065 11.2787 6.99534C13.6193 9.33601 14.4733 12.4407 13.142 13.772Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M37.0773 6.42536L35.0773 4.42536C32.698 2.04403 27.9173 3.10003 24.194 6.82403C22.5482 8.40628 21.361 10.4041 20.758 12.606C20.248 14.718 20.6153 16.5287 21.7926 17.7067H21.796L23.796 19.7067C24.6962 20.5641 25.905 21.0209 27.1473 20.9734C29.4873 20.9734 32.2986 19.684 34.6806 17.3067C38.4 13.5834 39.456 8.80336 37.0773 6.42536ZM22.054 12.9187C22.5997 10.9555 23.6646 9.17568 25.1366 7.76669C27.218 5.68536 29.7673 4.50736 31.7566 4.50736C32.6321 4.46334 33.4885 4.77299 34.1333 5.36669C34.968 6.20336 35.21 7.56669 34.8133 9.20936C34.2688 11.1729 33.2048 12.9532 31.7333 14.3627C28.6433 17.452 24.524 18.5507 22.7333 16.7627C21.8993 15.9274 21.6566 14.562 22.054 12.9187ZM24.9826 18.9667C25.036 18.9667 25.0886 18.9727 25.1433 18.9727C27.484 18.9727 30.2953 17.6834 32.6766 15.3027C34.3217 13.7203 35.5087 11.7228 36.112 9.52136C36.2671 8.89012 36.3383 8.24121 36.324 7.59136C37.8266 9.47936 36.7033 13.3914 33.736 16.3627C30.7773 19.3227 26.8793 20.45 24.9826 18.9667Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M17.87 0.5C17.5018 0.5 17.2034 0.798477 17.2034 1.16667V3.16667C17.2034 3.53486 17.5018 3.83333 17.87 3.83333C18.2382 3.83333 18.5367 3.53486 18.5367 3.16667V1.16667C18.5367 0.798477 18.2382 0.5 17.87 0.5Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M17.2034 7.83329C17.2034 8.20148 17.5018 8.49996 17.87 8.49996C18.2382 8.49996 18.5367 8.20148 18.5367 7.83329V5.83329C18.5367 5.4651 18.2382 5.16663 17.87 5.16663C17.5018 5.16663 17.2034 5.4651 17.2034 5.83329V7.83329Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M19.2033 5.16671H21.2033C21.5715 5.16671 21.87 4.86823 21.87 4.50004C21.87 4.13185 21.5715 3.83337 21.2033 3.83337H19.2033C18.8351 3.83337 18.5366 4.13185 18.5366 4.50004C18.5366 4.86823 18.8351 5.16671 19.2033 5.16671Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M16.5368 3.83337H14.5368C14.1686 3.83337 13.8701 4.13185 13.8701 4.50004C13.8701 4.86823 14.1686 5.16671 14.5368 5.16671H16.5368C16.905 5.16671 17.2035 4.86823 17.2035 4.50004C17.2035 4.13185 16.905 3.83337 16.5368 3.83337Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M33.4715 24.6953C33.2112 24.4351 32.7892 24.4351 32.5288 24.6953L31.1955 26.0286C31.0222 26.196 30.9527 26.4439 31.0137 26.677C31.0747 26.9101 31.2567 27.0921 31.4898 27.1531C31.7229 27.2141 31.9708 27.1446 32.1382 26.9713L33.4715 25.638C33.7317 25.3776 33.7317 24.9556 33.4715 24.6953Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M29.1953 28.0287L27.862 29.362C27.6887 29.5294 27.6192 29.7773 27.6802 30.0104C27.7412 30.2435 27.9232 30.4255 28.1563 30.4865C28.3894 30.5475 28.6373 30.478 28.8047 30.3047L30.138 28.9714C30.3906 28.7098 30.387 28.294 30.1299 28.0368C29.8727 27.7797 29.4569 27.776 29.1953 28.0287Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M32.1381 28.0287C31.8765 27.776 31.4607 27.7797 31.2036 28.0368C30.9464 28.294 30.9428 28.7098 31.1954 28.9714L32.5288 30.3047C32.7904 30.5573 33.2062 30.5537 33.4633 30.2966C33.7205 30.0394 33.7241 29.6236 33.4714 29.362L32.1381 28.0287Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M30.1379 26.0287L28.8046 24.6953C28.543 24.4427 28.1272 24.4463 27.8701 24.7034C27.6129 24.9606 27.6093 25.3764 27.8619 25.638L29.1953 26.9713C29.4569 27.224 29.8727 27.2204 30.1298 26.9632C30.387 26.706 30.3906 26.2902 30.1379 26.0287Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M12.0353 29.1C12.1935 29.1791 12.3767 29.1921 12.5445 29.1361C12.7123 29.0801 12.851 28.9597 12.93 28.8014L15.5966 23.468C15.7612 23.1385 15.6275 22.7379 15.298 22.5734C14.9684 22.4088 14.5679 22.5425 14.4033 22.872L11.7366 28.2054C11.6575 28.3636 11.6445 28.5468 11.7006 28.7146C11.7566 28.8824 11.877 29.021 12.0353 29.1Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M14.702 31.1C14.8603 31.1791 15.0435 31.1921 15.2113 31.136C15.3791 31.08 15.5177 30.9596 15.5967 30.8013L16.93 28.1346C17.0946 27.8051 16.9609 27.4046 16.6314 27.24C16.3019 27.0754 15.9013 27.2091 15.7367 27.5386L14.4034 30.2053C14.3243 30.3635 14.3113 30.5467 14.3673 30.7145C14.4233 30.8823 14.5437 31.021 14.702 31.1Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M25.74 11.0526C25.8118 11.0528 25.8832 11.0411 25.9513 11.0179L31.608 9.13261C31.9577 9.01608 32.1468 8.63806 32.0303 8.28828C31.9138 7.9385 31.5357 7.74942 31.186 7.86595L25.5293 9.75328C25.2188 9.85644 25.029 10.1697 25.0814 10.4926C25.1338 10.8156 25.4128 11.0529 25.74 11.0526Z"
                                                  fill="#61C19B"
                                                />
                                                <path
                                                  d="M28.8287 12.11L26 13.0534C25.7738 13.1287 25.6049 13.3191 25.557 13.5528C25.5092 13.7864 25.5896 14.0278 25.768 14.1861C25.9465 14.3444 26.1958 14.3954 26.422 14.32L29.25 13.3774C29.5998 13.2608 29.7889 12.8828 29.6724 12.533C29.5558 12.1833 29.1778 11.9942 28.828 12.1107L28.8287 12.11Z"
                                                  fill="#61C19B"
                                                />
                                              </svg>
                                            </i>
                                          </div>
                                          <div>Point3</div>
                                        </div>
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>
                                </Col>
                                <Col xl={9} lg={8} md={7}>
                                  <Tab.Content>
                                    <Tab.Pane eventKey="holders">
                                      <Card
                                        className="bg-primary rounded-3 position-relative"
                                        style={{ minHeight: "279px" }}
                                      >
                                         <div className="bgright position-absolute top-0 bottom-0 end-0">
                                          <img src="assets/images/shape/circleshadow.svg"  className="h-100"/>
                                        </div>
                                        <Card.Body className="p-4">
                                          <div className="position-relative">
                                            <h3 className="text-white mb-3">
                                              There are four key benefits for
                                              UNITRONIX token holders:
                                            </h3>
                                            <ol className="ps-3">
                                              <li className="mb-3">
                                                Access to projects at the
                                                earliest rounds, enabling
                                                investors to access best prices
                                                without the associated minimum
                                                threshold reserved for
                                                investment funds.
                                              </li>
                                              <li className="mb-3">
                                                Investment through a regulatory
                                                compliant means.
                                              </li>
                                              <li className="mb-3">
                                                Peace of mind investments are
                                                made in to bona fide projects
                                                that have been vetted on a
                                                number of levels.
                                              </li>
                                              <li>
                                                Chance to become a meaningful
                                                part of new project’s
                                                communities.
                                              </li>
                                            </ol>
                                          </div>
                                        </Card.Body>
                                      </Card>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="point2">
                                      <Card
                                        className="bg-primary rounded-3 position-relative"
                                        style={{ minHeight: "279px" }}
                                      >
                                         <div className="bgright position-absolute top-0 bottom-0 end-0">
                                          <img src="assets/images/shape/circleshadow.svg"  className="h-100"/>
                                        </div>
                                        <Card.Body className="p-4">
                                          <div className="position-relative">
                                            <h3 className="text-white mb-3">
                                              There are four key benefits for
                                              UNITRONIX token holders:
                                            </h3>
                                            <ol className="ps-3 ">
                                              <li className="mb-3">
                                                Access to projects at the
                                                earliest rounds, enabling
                                                investors to access best prices
                                                without the associated minimum
                                                threshold reserved for
                                                investment funds.
                                              </li>
                                              <li className="mb-3">
                                                Investment through a regulatory
                                                compliant means.
                                              </li>
                                              <li className="mb-3">
                                                Peace of mind investments are
                                                made in to bona fide projects
                                                that have been vetted on a
                                                number of levels.
                                              </li>
                                              <li>
                                                Chance to become a meaningful
                                                part of new project’s
                                                communities.
                                              </li>
                                            </ol>
                                          </div>
                                        </Card.Body>
                                      </Card>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="point3">
                                      <Card
                                        className="bg-primary rounded-3 position-relative"
                                        style={{ minHeight: "279px" }}
                                      >
                                        <div className="bgright position-absolute top-0 bottom-0 end-0">
                                          <img src="assets/images/shape/circleshadow.svg"  className="h-100"/>
                                        </div>
                                        <Card.Body className="p-4">
                                          <div>
                                            <h3 className="text-white mb-3">
                                              There are four key benefits for
                                              UNITRONIX token holders:
                                            </h3>
                                            <ol className="ps-3">
                                              <li className="mb-3">
                                                Access to projects at the
                                                earliest rounds, enabling
                                                investors to access best prices
                                                without the associated minimum
                                                threshold reserved for
                                                investment funds.
                                              </li>
                                              <li className="mb-3">
                                                Investment through a regulatory
                                                compliant means.
                                              </li>
                                              <li className="mb-3">
                                                Peace of mind investments are
                                                made in to bona fide projects
                                                that have been vetted on a
                                                number of levels.
                                              </li>
                                              <li>
                                                Chance to become a meaningful
                                                part of new project’s
                                                communities.
                                              </li>
                                            </ol>
                                          </div>
                                        </Card.Body>
                                      </Card>
                                    </Tab.Pane>
                                  </Tab.Content>
                                </Col>
                              </Row>
                            </Tab.Container>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="projectlist">
          <Container>
            <Row>
              <Col lg={12}>
                <Row className="align-items-center">
                  <Col lg={7} className="mb-4">
                    <div className="heading">
                      <h1 className="text-white fw-normal mb-3">
                        Project List
                      </h1>
                    </div>
                  </Col>
                  <Col lg={5} className="mb-4">
                    <div>
                      <InputGroup className="gap-3 rounded-2">
                        <Form.Control
                          placeholder="Search by Pool name, Token Symbol"
                          aria-label="Search by Pool name, Token Symbol"
                          aria-describedby="basic-addon2"
                          className="fw-light small"
                        />
                        <Button
                          variant="default"
                          id="button-addon2"
                          className="fw-light"
                        >
                          <span className="me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="16"
                              viewBox="0 0 25 24"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_607_12990)">
                                <path
                                  d="M21.6875 1.875H20.5625V0H18.6875V1.875H6.3125V0H4.4375V1.875H3.3125C1.76169 1.875 0.5 3.13669 0.5 4.6875V21.1875C0.5 22.7383 1.76169 24 3.3125 24H21.6875C23.2383 24 24.5 22.7383 24.5 21.1875V4.6875C24.5 3.13669 23.2383 1.875 21.6875 1.875ZM22.625 21.1875C22.625 21.7044 22.2044 22.125 21.6875 22.125H3.3125C2.79556 22.125 2.375 21.7044 2.375 21.1875V8.8125H22.625V21.1875ZM22.625 6.9375H2.375V4.6875C2.375 4.17056 2.79556 3.75 3.3125 3.75H4.4375V5.625H6.3125V3.75H18.6875V5.625H20.5625V3.75H21.6875C22.2044 3.75 22.625 4.17056 22.625 4.6875V6.9375Z"
                                  fill="white"
                                />
                                <path
                                  d="M5.9375 10.7812H4.0625V12.6562H5.9375V10.7812Z"
                                  fill="white"
                                />
                                <path
                                  d="M9.6875 10.7812H7.8125V12.6562H9.6875V10.7812Z"
                                  fill="white"
                                />
                                <path
                                  d="M13.4375 10.7812H11.5625V12.6562H13.4375V10.7812Z"
                                  fill="white"
                                />
                                <path
                                  d="M17.1875 10.7812H15.3125V12.6562H17.1875V10.7812Z"
                                  fill="white"
                                />
                                <path
                                  d="M20.9375 10.7812H19.0625V12.6562H20.9375V10.7812Z"
                                  fill="white"
                                />
                                <path
                                  d="M5.9375 14.5312H4.0625V16.4062H5.9375V14.5312Z"
                                  fill="white"
                                />
                                <path
                                  d="M9.6875 14.5312H7.8125V16.4062H9.6875V14.5312Z"
                                  fill="white"
                                />
                                <path
                                  d="M13.4375 14.5312H11.5625V16.4062H13.4375V14.5312Z"
                                  fill="white"
                                />
                                <path
                                  d="M17.1875 14.5312H15.3125V16.4062H17.1875V14.5312Z"
                                  fill="white"
                                />
                                <path
                                  d="M5.9375 18.2812H4.0625V20.1562H5.9375V18.2812Z"
                                  fill="white"
                                />
                                <path
                                  d="M9.6875 18.2812H7.8125V20.1562H9.6875V18.2812Z"
                                  fill="white"
                                />
                                <path
                                  d="M13.4375 18.2812H11.5625V20.1562H13.4375V18.2812Z"
                                  fill="white"
                                />
                                <path
                                  d="M17.1875 18.2812H15.3125V20.1562H17.1875V18.2812Z"
                                  fill="white"
                                />
                                <path
                                  d="M20.9375 14.5312H19.0625V16.4062H20.9375V14.5312Z"
                                  fill="white"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_607_12990">
                                  <rect
                                    width="24"
                                    height="24"
                                    fill="white"
                                    transform="translate(0.5)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                          </span>{" "}
                          Calendar View
                        </Button>
                      </InputGroup>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col lg={12}>
                <Card>
                  <Card.Body className="pb-0 ">
                    <div>
                      <Row className="align-items-center">
                        <Col lg={12} className="">
                          <div className="tabStyle2">
                            <Tab.Container
                              id="left-tabs-example"
                              defaultActiveKey="upcoming"
                            >
                              <Row>
                                <Col xl={12} className="mb-5">
                                  <Nav variant="pills">
                                    <Nav.Item className="">
                                      <Nav.Link eventKey="upcoming">
                                        Upcoming [3]
                                      </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item className="">
                                      <Nav.Link eventKey="listed">
                                        Listed [10]
                                      </Nav.Link>
                                    </Nav.Item>
                                  </Nav>
                                </Col>
                                <Col xl={12}>
                                  <Tab.Content>
                                    <Tab.Pane eventKey="upcoming">
                                      <div>
                                        <Row>
                                          <Col xl={4} lg={6} md={6} className="mb-4">
                                            <Card className="bg-primary">
                                              <Card.Img
                                                variant="top"
                                                src="assets/images/project/project1.png"
                                              />
                                              <Card.Body className="p-4">
                                                <Card.Title className="mb-4">
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div>
                                                      <h3 className="text-white mb-0">
                                                        Axverse
                                                      </h3>
                                                    </div>
                                                    <div>
                                                      <img src="assets/images/icon/cryptocurrency.svg" />
                                                    </div>
                                                  </div>
                                                </Card.Title>
                                                <Card.Text>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Total Raise
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $250,000
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Token Price
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $0.521
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Start Date
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      TBA
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Type
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      Standard IDO
                                                    </div>
                                                  </div>
                                                </Card.Text>
                                                <div className="d-flex gap-3 align-items-center justify-content-between">
                                                  <Button
                                                    variant="primary-gradient"
                                                    className="w-100 border-0"
                                                  >
                                                    AME Allocation
                                                  </Button>
                                                  <Button
                                                    variant="outline-primary"
                                                    className="w-100"
                                                  >
                                                    Fixed Allocation
                                                  </Button>
                                                </div>
                                              </Card.Body>
                                            </Card>
                                          </Col>
                                          <Col xl={4} lg={6} md={6} className="mb-4">
                                            <Card className="bg-primary">
                                              <Card.Img
                                                variant="top"
                                                src="assets/images/project/project2.png"
                                              />
                                              <Card.Body className="p-4">
                                                <Card.Title className="mb-4">
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div>
                                                      <h3 className="text-white mb-0">
                                                        Vima Network
                                                      </h3>
                                                    </div>
                                                    <div>
                                                      <img src="assets/images/icon/cryptocurrency.svg" />
                                                    </div>
                                                  </div>
                                                </Card.Title>
                                                <Card.Text>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Total Raise
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $250,000
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Token Price
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $0.521
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Start Date
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      TBA
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Type
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      Standard IDO
                                                    </div>
                                                  </div>
                                                </Card.Text>
                                                <div className="d-flex gap-3 align-items-center justify-content-between">
                                                  <Button
                                                    variant="primary-gradient"
                                                    className="w-100 border-0"
                                                  >
                                                    AME Allocation
                                                  </Button>
                                                  <Button
                                                    variant="outline-primary"
                                                    className="w-100"
                                                  >
                                                    Fixed Allocation
                                                  </Button>
                                                </div>
                                              </Card.Body>
                                            </Card>
                                          </Col>
                                          <Col xl={4} lg={6} md={6} className="mb-4">
                                            <Card className="bg-primary">
                                              <Card.Img
                                                variant="top"
                                                src="assets/images/project/project3.png"
                                              />
                                              <Card.Body className="p-4">
                                                <Card.Title className="mb-4">
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div>
                                                      <h3 className="text-white mb-0">
                                                        Grand Protocol
                                                      </h3>
                                                    </div>
                                                    <div>
                                                      <img src="assets/images/icon/cryptocurrency.svg" />
                                                    </div>
                                                  </div>
                                                </Card.Title>
                                                <Card.Text>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Total Raise
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $250,000
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Token Price
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $0.521
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Start Date
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      TBA
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Type
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      Standard IDO
                                                    </div>
                                                  </div>
                                                </Card.Text>
                                                <div className="d-flex gap-3 align-items-center justify-content-between">
                                                  <Button
                                                    variant="primary-gradient"
                                                    className="w-100 border-0"
                                                  >
                                                    AME Allocation
                                                  </Button>
                                                  <Button
                                                    variant="outline-primary"
                                                    className="w-100"
                                                  >
                                                    Fixed Allocation
                                                  </Button>
                                                </div>
                                              </Card.Body>
                                            </Card>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="listed">
                                      <div>
                                        <Row>
                                          <Col xl={4} lg={6} md={6} className="mb-4">
                                            <Card className="bg-primary">
                                              <Card.Img
                                                variant="top"
                                                src="assets/images/project/project1.png"
                                              />
                                              <Card.Body className="p-4">
                                                <Card.Title className="mb-4">
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div>
                                                      <h2 className="text-white mb-0">
                                                        Axverse
                                                      </h2>
                                                    </div>
                                                    <div>
                                                      <img src="assets/images/icon/cryptocurrency.svg" />
                                                    </div>
                                                  </div>
                                                </Card.Title>
                                                <Card.Text>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Total Raise
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $250,000
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Token Price
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $0.521
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Start Date
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      TBA
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Type
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      Standard IDO
                                                    </div>
                                                  </div>
                                                </Card.Text>
                                                <div className="d-flex gap-3 align-items-center justify-content-between">
                                                  <Button
                                                    variant="primary-gradient"
                                                    className="w-100 border-0"
                                                  >
                                                    AME Allocation
                                                  </Button>
                                                  <Button
                                                    variant="outline-primary"
                                                    className="w-100"
                                                  >
                                                    Fixed Allocation
                                                  </Button>
                                                </div>
                                              </Card.Body>
                                            </Card>
                                          </Col>
                                          <Col xl={4} lg={6} md={6} className="mb-4">
                                            <Card className="bg-primary">
                                              <Card.Img
                                                variant="top"
                                                src="assets/images/project/project2.png"
                                              />
                                              <Card.Body className="p-4">
                                                <Card.Title className="mb-4">
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div>
                                                      <h2 className="text-white mb-0">
                                                        Vima Network
                                                      </h2>
                                                    </div>
                                                    <div>
                                                      <img src="assets/images/icon/cryptocurrency.svg" />
                                                    </div>
                                                  </div>
                                                </Card.Title>
                                                <Card.Text>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Total Raise
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $250,000
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Token Price
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $0.521
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Start Date
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      TBA
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Type
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      Standard IDO
                                                    </div>
                                                  </div>
                                                </Card.Text>
                                                <div className="d-flex gap-3 align-items-center justify-content-between">
                                                  <Button
                                                    variant="primary-gradient"
                                                    className="w-100 border-0"
                                                  >
                                                    AME Allocation
                                                  </Button>
                                                  <Button
                                                    variant="outline-primary"
                                                    className="w-100"
                                                  >
                                                    Fixed Allocation
                                                  </Button>
                                                </div>
                                              </Card.Body>
                                            </Card>
                                          </Col>
                                          <Col xl={4} lg={6} md={6} className="mb-4">
                                            <Card className="bg-primary">
                                              <Card.Img
                                                variant="top"
                                                src="assets/images/project/project3.png"
                                              />
                                              <Card.Body className="p-4">
                                                <Card.Title className="mb-4">
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div>
                                                      <h2 className="text-white mb-0">
                                                        Grand Protocol
                                                      </h2>
                                                    </div>
                                                    <div>
                                                      <img src="assets/images/icon/cryptocurrency.svg" />
                                                    </div>
                                                  </div>
                                                </Card.Title>
                                                <Card.Text>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Total Raise
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $250,000
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Token Price
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      $0.521
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Start Date
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      TBA
                                                    </div>
                                                  </div>
                                                  <div className="d-flex align-items-center justify-content-between">
                                                    <div className="text-grey mb-3">
                                                      Type
                                                    </div>
                                                    <div className="text-white mb-3">
                                                      Standard IDO
                                                    </div>
                                                  </div>
                                                </Card.Text>
                                                <div className="d-flex gap-3 align-items-center justify-content-between">
                                                  <Button
                                                    variant="primary-gradient"
                                                    className="w-100 border-0"
                                                  >
                                                    AME Allocation
                                                  </Button>
                                                  <Button
                                                    variant="outline-primary"
                                                    className="w-100"
                                                  >
                                                    Fixed Allocation
                                                  </Button>
                                                </div>
                                              </Card.Body>
                                            </Card>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Tab.Pane>
                                  </Tab.Content>
                                </Col>
                              </Row>
                            </Tab.Container>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="getintouch pt-0">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8} className="mb-4 text-center">
                <div className="heading my-4">
                  <h1 className="text-white">
                    It’s time to join the growing community of investors,
                    innovators, and institutions transforming DeFi with
                    Unitronix
                  </h1>
                </div>
                <Button variant="primary" className="text-black">
                  Connect Wallet
                </Button>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </>
  );
};
export default Home2;
